import React from "react";
import { tt } from "../../../../../utils/i18n/i18n";
import KC_Card from "../../../../../designsystem/KC_Card/KC_Card";
import { KC_PaddingEnum } from "../../../../../designsystem/KC_Card/component/model/KC_PaddingEnum";
import KC_Heading2 from "../../../../../designsystem/typography/KC-Heading/KC_Heading2";
import KC_Text from "../../../../../designsystem/typography/KC_Text/KC_Text";
import {
  KC_Weights,
  KC_Text_Sizes
} from "../../../../../designsystem/ds_commons";
import KC_Button, {
  KC_ButtonSize
} from "../../../../../designsystem/KC_Button/KC_Button";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import TwemojiWrapper from "../../../../../components/TwemojiWrapper/TwemojiWrapper";
import { TranslationsKeys } from "../../../../../utils/i18n/translations/Translations";

export interface LandingCardProps {
  titleKey: keyof TranslationsKeys;
  descriptionKey: keyof TranslationsKeys;
  icon: string;
  onClick: () => void;
}

const LandingCard = ({
  titleKey,
  descriptionKey,
  icon,
  onClick
}: LandingCardProps) => (
  <KC_Card
    padding={KC_PaddingEnum.gift}
    boxShadow={true}
    className="flex-grow-1 loyalty-gifts-landing-card"
    isGiftCard={true}
  >
    <button
      type="button"
      className="w-100 h-100 d-flex flex-column align-items-start st-gap p-3 border-0 bg-transparent text-start"
      onClick={onClick}
    >
      <div className="d-flex align-items-center st-gap">
        <TwemojiWrapper isBigText={true}>{icon}</TwemojiWrapper>
        <KC_Heading2 text={tt(titleKey)} />
      </div>
      <KC_Text
        size={KC_Text_Sizes.md}
        weight={KC_Weights.reg}
        text={tt(descriptionKey)}
        className="text-secondary"
      />
      <KC_Button
        size={KC_ButtonSize.Medium}
        text={tt("loyalty_choose_my_gifts")}
        isPrimary={true}
        showIconOnTheRight={true}
        icon={faArrowRight}
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick();
        }}
      />
    </button>
  </KC_Card>
);

export default LandingCard;
